import React from 'react';
import { Link } from 'react-router-dom';
import './PartnerDemoPages.css';

const DEMO_QUESTIONNAIRES = [
  { id: '1', name: 'QCB Third-Party Questionnaire', from: 'Qatar Central Bank', status: 'Completed', due: '2025-01-15' },
  { id: '2', name: 'ISO 27001 Security Assessment', from: 'Gulf Bank', status: 'In progress', due: '2025-02-01' },
  { id: '3', name: 'GDPR Data Processing', from: 'MENA Finance Co.', status: 'Pending', due: '2025-02-10' },
];

function getBadgeClass(status: string) {
  if (status === 'Completed') return 'badge-success';
  if (status === 'In progress') return 'badge-warning';
  return 'badge-secondary';
}

export default function DemoPartnerQuestionnaires() {
  return (
    <div className="partner-demo-page">
      <nav className="page-breadcrumb">
        <Link to="/">Home</Link>
        <span className="mx-2">/</span>
        <span>Questionnaires</span>
      </nav>
      <header className="page-header">
        
        <p className="page-subtitle mb-0">
          Questionnaires and assessments requested by institutions. Complete and submit by the due date.
        </p>
      </header>

      <div className="card-partner">
        <div className="card-header-partner">Assigned questionnaires</div>
        <div className="card-body-partner p-0">
          <table className="table-partner">
            <thead>
              <tr>
                <th>Questionnaire</th>
                <th>Requested by</th>
                <th>Status</th>
                <th>Due date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {DEMO_QUESTIONNAIRES.map((q) => (
                <tr key={q.id}>
                  <td>{q.name}</td>
                  <td>{q.from}</td>
                  <td><span className={`badge-partner ${getBadgeClass(q.status)}`}>{q.status}</span></td>
                  <td>{q.due}</td>
                  <td><button type="button" className="btn btn-partner-primary btn-sm">Open</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
